module.exports = __webpack_public_path__ + "static/media/expired-chop.b4129b0c.png";